<template>
  <div class="margin-top">
    <el-row :gutter="20" class="mb-10">
      <el-col :span="6">
        <el-input v-model="searchForm.staffName" placeholder="请填写员工名称" clearable></el-input>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" @click="handleSearch">
          <i class="el-icon-search"></i>查询
        </el-button>
        <el-button type="primary" @click="openAddModal">
          <i class="el-icon-plus"></i>关联员工
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="tel" label="手机号" align="center"></el-table-column>
      <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
      <el-table-column prop="address" label="地址" align="center"></el-table-column>
      <el-table-column prop="sex" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 0 ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="openDeleteModal(scope.row)">删除</el-button>
          <el-button size="mini" type="text" @click="toStaffDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="mt-10" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>

    <add-role-staff ref="addRoleStaff" @refresh="loadStaffs"></add-role-staff>
    <delete-role-staff ref="deleteRoleStaff" @refresh="loadStaffs"></delete-role-staff>
  </div>
</template>

<script>
import AddRoleStaff from '@/components/frame/addRoleStaff/addRoleStaff'
import DeleteRoleStaff from '@/components/frame/deleteRoleStaff/deleteRoleStaff'
import { getRoleStaffList } from '@/api/frame/roleStaffApi'

export default {
  name: 'RoleStaff',
  components: {
    AddRoleStaff,
    DeleteRoleStaff
  },
  data() {
    return {
      searchForm: {
        staffName: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      roleId: ''
    }
  },
  methods: {
    openRoleStaff(params) {
      this.roleId = params.pgId
      this.loadStaffs()
    },
    async loadStaffs() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          roleId: this.roleId,
          userName: this.searchForm.staffName
        }
        const res = await getRoleStaffList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取员工列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadStaffs()
    },
    openAddModal() {
      this.$refs.addRoleStaff.open({
        roleId: this.roleId
      })
    },
    openDeleteModal(staff) {
      this.$refs.deleteRoleStaff.open({
        ...staff,
        roleId: this.roleId
      })
    },
    toStaffDetail(staff) {
      this.$router.push(`/pages/frame/staffDetail?staffId=${staff.userId}`)
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadStaffs()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadStaffs()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mt-10 {
  margin-top: 10px;
}
</style>